// extracted by mini-css-extract-plugin
export default {"container":"ball_container__ReKYt","content":"ball_content__am3R9","ball":"ball_ball__GBTN-","shadow":"ball_shadow__6PaxT","icon":"ball_icon__2Kb1k","result":"ball_result__CnNCr"};